import classNames from 'classnames';
import React from 'react';
import styles from './Switch.module.scss';
function Switch({ name, label = null, value = false, size = 'm', disabled = false, onChange, }) {
    const wrapClasses = classNames(styles.wrap, styles[size], { [styles.disabled]: disabled });
    const iconClasses = classNames(styles.icon, styles[size], { [styles.on]: value });
    const labelClasses = classNames(styles.label, styles[size], { [styles.on]: value });
    return (React.createElement("div", { className: wrapClasses },
        React.createElement("div", { className: iconClasses },
            React.createElement("div", null),
            React.createElement("input", { type: "checkbox", name: name, checked: value, onChange: onChange, disabled: disabled })),
        label && (React.createElement("label", { htmlFor: name, className: labelClasses }, label))));
}
export default Switch;
